import dynamic from 'next/dynamic';
import { ComponentProps } from './ReservationSummary.types';

export const ReservationSummaryV1MGP = dynamic<ComponentProps>(() => import('./ReservationSummary'));
export const ReservationSummaryV2MGP = dynamic<ComponentProps>(() => import('./ReservationSummaryV2'));

export const ReservationSummaryMGP = (props: ComponentProps) => {
  if (props?.newResSummary) return <ReservationSummaryV2MGP {...props} />;
  return <ReservationSummaryV1MGP {...props} />;
};
// import('./ReservationSummary').then(module => module.ReservationSummary)
